// extracted by mini-css-extract-plugin
module.exports = {"button":"action-typeform_button__YuLuV primary_button__NwV8F core_block__YzES_ core_core__AB9_0 primary_medium__jT7Xj core_medium__sEupA"};